import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useSelector } from 'react-redux';

function ScorePage() {
  const result = useSelector((state) => state.result);

 console.log(result);

  return (
    <Box sx={{ p: 4, maxWidth: 800, margin: "auto", backgroundColor: "#f9f9f9", borderRadius: 2, boxShadow: 3 }}>
      {/* Header Section */}
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6" fontWeight="bold">
          Student Name: {result.name}
        </Typography>
        <Typography>Class: {result.class}</Typography>
        <Typography>School: {result.school}</Typography>
      </Box>

      {/* Total Marks */}
     

      {/* Scores Table */}
      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}> TOTAL MARKS: {result.totalMarks}</TableCell>
              <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>Final Obtained</TableCell>
              <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>Average  (%)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {result.scores.map((score, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Box display="flex" alignItems="center" gap={1}>
                    <span style={{ fontSize: "12px" }}><img src={`/images/${index + 1}.jpeg`} alt="Next" style={{ width: '30px', height: 'auto' }} /></span>
                    <Typography>{score.test}</Typography>
                  </Box>
                </TableCell>
                <TableCell>{score.rightAnswer}/{score.TotalQue}</TableCell>
                <TableCell>{((score.rightAnswer / score.TotalQue) * 100).toFixed(0)}%</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default ScorePage;
